import dataTable from './table/data-table';
import baseHeader from './baseHeader/index';
import baseFooter from './baseFooter/index';
import baseLeft from './baseLeft/index';
export default { baseHeader, baseFooter, baseLeft, dataTable }



// WEBPACK FOOTER //
// ./src/modules/index.js